// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3s1aYr2FQYtltoW_U093pK {\n  line-height: var(--striking-line-height);\n}\n\n._1Al2xVXOrsYwTheDcCqfhO {\n  margin-left: var(--space-small);\n}\n\n@media (max-width: 767px) {\n  ._3s1aYr2FQYtltoW_U093pK {\n    margin-bottom: var(--space-small);\n  }\n\n  ._3s1aYr2FQYtltoW_U093pK:last-child {\n    margin-bottom: 0;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"interview": "_3s1aYr2FQYtltoW_U093pK",
	"media": "_1Al2xVXOrsYwTheDcCqfhO"
};
module.exports = exports;
